module.exports = __webpack_public_path__ + "static/media/nullAvatar.d1422a70.png";